












































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import NewIndicator from '@/components/NewIndicator.vue';
import AddTicketModal from '@/components/tickets/AddTicketModal.vue';
import { Ticket } from '@/core/interfaces/ticket';
import axios from 'axios';
import { newAppAlarmUrl, newAppUrl } from '@/core/newAppUrl';
import { Notification } from '@/core/interfaces/notification';

@Component({
    components: { AddTicketModal, NewIndicator },
})
export default class NavigationSidebar extends Vue {
    id = '';
    searching = false;

    @Getter('isInternalUser')
    isInternalUser!: boolean;

    // Alarms, tickets and vehicles have all moved to the new (Angular) Alarm
    // Center, so every one of those nav items links out to it. The badge counts
    // still come from this app's own store, which keeps syncing.
    newAppAlarmsUrl(view: 'open' | 'assigned' | 'recent' | 'archive'): string {
        return newAppUrl(`/alarms/${view}`);
    }

    newAppTicketsUrl(view: 'unassigned' | 'assigned' | 'closed'): string {
        return newAppUrl(`/tickets/${view}`);
    }

    newAppVehiclesUrl(): string {
        return newAppUrl('/vehicles');
    }

    mounted(): void {
        document.addEventListener('keydown', (event: KeyboardEvent) => {
            // only when not focused on an input field
            if (
                event.target instanceof HTMLInputElement ||
                event.target instanceof HTMLTextAreaElement ||
                (event.target instanceof HTMLElement &&
                    event.target.isContentEditable)
            ) {
                return;
            }

            if (event.key === '/') {
                event.preventDefault();
                const searchInput = this.$refs.search_id_input as
                    | HTMLInputElement
                    | undefined;

                if (searchInput) {
                    searchInput.focus();
                }
            }
        });
    }

    async search(): Promise<void> {
        this.searching = true;

        try {
            const notification = (
                await axios.get<Notification>(`/notifications/${this.id}`)
            ).data;

            if (!notification) {
                this.$bvToast.toast(
                    'Notification with ID ' + this.id + ' was not found.',
                    {
                        title: this.$t('general.error').toString(),
                        variant: 'danger',
                        solid: true,
                    },
                );

                return;
            }

            // The alarm itself opens in the new Alarm Center, run and all —
            // this app only still checks that the ID exists.
            window.location.href = newAppAlarmUrl(
                String(notification.id),
                notification.notification_run_id
                    ? String(notification.notification_run_id)
                    : undefined,
            );
        } finally {
            this.id = '';
            this.searching = false;
        }
    }

    @Getter('runs/openNotifications')
    protected openNotifications!: Notification[];

    @Getter('runs/assignedNotifications')
    protected assignedNotifications!: Notification[];

    @Getter('runs/notificationsAssignedToMe')
    protected assignedToMeNotifications!: Notification[];

    @Getter('tickets/assignedToMe')
    protected ticketsAssignedToMe!: Ticket[];

    @Getter('tickets/openTickets')
    protected openTickets!: Ticket[];

    @Getter('tickets/unseenMessagesTicketsAssignedToMe')
    protected unseenMessagesTicketsAssignedToMe!: number;
}
